import React, { useEffect, useState } from 'react'

// Material UI
import AppBar from '@material-ui/core/AppBar'
import CardContent from '@material-ui/core/CardContent'
import Grid from "@material-ui/core/Grid"
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

// Components
import ItemFooter from './ItemFooter'
import ItemPanels from './ItemPanels'
// Icons
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

// Notification
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'

// Translation
import { Language } from '../../Translation'

// CSS
import './Item.css'

// React Router
import { useParams } from "react-router"

// Redux
import { connect } from 'react-redux'
import { addToCart } from '../../redux/actions/cartActions'

const Item = ({ item, toggleDrawer, clientData, addToCart }) => {

  const { client, language } = clientData
  const { name } = useParams()

  const [options, setOptions] = useState([])
  const [totalOptions, setTotalOptions] = useState(0)

  const [ingredients, setIngredients] = useState([])
  const [totalIngredients, setTotalIngredients] = useState(0)

  const [quantity, setQuantity] = useState(1)
  const [notes, setNotes] = useState('')

  const notify = () => {
    toast.info(item.Name + Language.ItemNotifcationAddToCart[language], {
      toastId: "itemAdded"
    })
  }

  const notifyRequiredOptions = (message) => {
    toast.error(Language.ItemRequiredOptions[language] + message)
  }

  useEffect(() => {
    setTotalIngredients(ingredients.reduce((sum, ingredient) => sum + ingredient.price, 0))
  }, [ingredients])

  const addQuantity = () => {
    setQuantity(quantity + 1)
  }

  const removeQuantity = () => {
    if (quantity > 1) { setQuantity(quantity - 1) }
  }

  const updateTotalOptionsAmount = () => {

    let totalOptions = 0

    if (item.HighestPrice) {
      totalOptions = Math.max.apply(Math, options.map(function (choice) { return choice.price }))
    } else {
      options.forEach(choice => {
        if (choice !== undefined)
          totalOptions += choice.price
      })
    }

    setTotalOptions(totalOptions)

  }

  const addOptions = (index, listOfChoices) => {

    if (!options[index]) {
      options[index] = {
        options: []
      }
    }

    options[index] = listOfChoices

    setOptions(options)
    updateTotalOptionsAmount()

  }

  const addIngredients = (ingredient) => {

    if (ingredient !== null) {

      let ing = [...ingredients]
      let ingredientIndex = ingredients.findIndex(ing => ing.UID === ingredient.UID)

      if (ingredientIndex === -1) {

        //Add Ingredient to Array
        ing = [...ingredients, ingredient]

      } else {

        if (ingredient.value === null) {

          // Erase Ingredient
          ing.splice(ingredientIndex, 1)

        } else {
          // Update Ingredient
          ing[ingredientIndex] = ingredient
        }

      }
      setIngredients(ing)
    }
  }

  const handleRequireOption = () => {

    let status = true

    options.forEach(option => {
      if (option.selected < option.expected) {
        status = false
        notifyRequiredOptions(option.name)
      }
    })

    return status

  }

  const guidGenerator = () => {
    var guid = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return (guid() + guid())
  }

  let price = item[client.diningOption] === 0 ? item.Price : item[client.diningOption]
  let totalAmount = quantity * (price + totalIngredients + totalOptions)

  const addItemToCart = () => {

    let price = item[client.diningOption] === 0 ? item.Price : item[client.diningOption]

    var itemToCart = {
      guid: guidGenerator(),
      name: item.Name,
      UID: item.UID,
      highestPrice: item.HighestPrice,
      price: price,
      priceTotalOptions: totalOptions,
      priceTotalIngredients: totalIngredients,
      quantity: quantity,
      discount: 0,
      discountPercent: 0,
      discountName: '',
      notes: notes,
      subOptions: options,
      subIngredients: ingredients,
    }

    if (handleRequireOption()) {

      addToCart(itemToCart)

      // Close Drawer & Display Notification
      toggleDrawer()

      // Notify User
      notify()

    }

  }

  const styles = { marginLeft: -20 }

  if (!item.length === 0) {
    return <div>Loading....</div>
  }

  return (
    <>
      <AppBar style={{ position: 'static', backgroundColor: "#003366" }}>
        <Toolbar>
          <IconButton style={styles} onClick={() => toggleDrawer()} color="inherit" aria-label="ArrowBackIcon">
            <ArrowBackIcon />
            <span style={{ paddingLeft: 15 }}>{Language.ItemReturnToMenu[language]}</span>
          </IconButton>
        </Toolbar>
      </AppBar>

      {item.Picture &&
        <img
          height={220}
          width="auto"
          src={name + "/pictures/" + item.Picture}
          alt=''
        />
      }

      <Grid item>
        <CardContent>
          <Typography variant="h5" component="h2">
            {item.Name}
          </Typography>
          <Typography variant="h6" color="textSecondary" gutterBottom >
            {Language.ItemPrice[language]}: {price.toFixed(2)}$
          </Typography>
          <Typography className="title" color="textSecondary" gutterBottom>
            {item.Comment}
          </Typography>
        </CardContent>
      </Grid>

      <ItemPanels
        item={item}
        addOptions={addOptions}
        addIngredients={addIngredients}
        setNotes={setNotes}
        notes={notes}
      />

      <ItemFooter
        quantity={quantity}
        addQuantity={addQuantity}
        removeQuantity={removeQuantity}
        addItemToCart={addItemToCart}
        totalAmount={totalAmount}
      />

    </>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    addToCart: (item) => dispatch(addToCart(item))
  }
}

const mapStateToProps = (state) => {
  return {
    cartData: state.cartData,
    clientData: state.clientData
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Item)